<script setup lang="ts">
import type { FieldProps } from "../ui/auto-form";

defineProps<FieldProps>();
</script>

<template>
  <FormField v-slot="slotProps" :name="fieldName">
    <FormItem v-bind="$attrs">
      <AutoFormLabel v-if="!config?.hideLabel" :required="required">
        {{ config?.label }}
      </AutoFormLabel>
      <FormControl>
        <AdminAdministrationUnitSelect v-bind="slotProps" v-model="slotProps.value" @update:model-value="(v) => slotProps.setValue(v)" />
      </FormControl>
      <FormDescription v-if="config?.description">
        {{ config.description }}
      </FormDescription>
      <FormMessage />
    </FormItem>
  </FormField>
</template>
